import { Flex, Text } from "@simplybusiness/mobius";

type TotalRowProps = {
  amount: string;
  isBold: boolean;
};

export const TotalRow = ({ amount, isBold }: TotalRowProps) => (
  <Flex
    className="mobius-payment-summary__total-row"
    data-testid="total-payment-amount"
  >
    <Text>{isBold ? <strong>Total</strong> : "Total"} (inc. tax + fees)</Text>
    <Text>{isBold ? <strong>{amount}</strong> : amount}</Text>
  </Flex>
);

TotalRow.displayName = "TotalRow";
